/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import {
  ActionIcon,
  Box,
  Card,
  Flex,
  Group,
  Image,
  Menu,
  Text,
} from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import { IconCopy, IconDotsVertical, IconTrash } from "@tabler/icons-react";
import { appShowNotification } from "@/utils/utils";

interface CardProps {
  createdAt: string;
  text: string;
  isSummarized: boolean;
  onDelete: () => void;
  hideDeleteAction?: boolean;
}

const CardComponent: React.FC<CardProps> = ({
  createdAt,
  text,
  isSummarized,
  onDelete,
  hideDeleteAction = false,
}) => {
  const clipboard = useClipboard();
  return (
    <Card className="case-card-detail-item" withBorder mb={10}>
      <Group align="center">
        <Box flex={1}>
          <Flex align={"center"}>
            {isSummarized && (
              <Image
                src="/assets/icons8-sparkle.gif"
                style={{ height: 12, width: 12, marginRight: 4 }}
              />
            )}
            <Text flex={1} fz={14}>
              {new Date(createdAt).toLocaleString([], {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </Text>
          </Flex>
          <Box className="case-card-detail-body">
            <Text fz={14}>{text}</Text>
          </Box>
        </Box>
        <Menu
          position="bottom-end"
          shadow="md"
          withArrow
          radius={"sm"}
          offset={-5}
          arrowOffset={10}
        >
          <Menu.Target>
            <ActionIcon bg={"transparent"} variant="subtle">
              <IconDotsVertical size={24} color="black" />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              leftSection={<IconCopy size={18} />}
              onClick={() => {
                clipboard.copy(text);
                appShowNotification({
                  title: "Copied to the clipboard",
                  type: "success",
                });
              }}
            >
              {"Copy text"}
            </Menu.Item>
            {!hideDeleteAction && <Menu.Divider />}
            {!hideDeleteAction && (
              <Menu.Item
                c={"red"}
                leftSection={<IconTrash size={18} />}
                onClick={onDelete}
              >
                {"Delete"}
              </Menu.Item>
            )}
          </Menu.Dropdown>
        </Menu>
      </Group>
    </Card>
  );
};

export default CardComponent;
